import { Sun, Moon } from "@phosphor-icons/react";
import { useTheme } from "@/contexts/ThemeContext";

export const ThemeToggle = ({ className = "" }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      data-testid="theme-toggle-button"
      aria-label="Toggle theme"
      className={`inline-flex items-center justify-center w-10 h-10 rounded-full border border-slate-300 dark:border-white/15 text-slate-600 dark:text-slate-300 hover:text-teal-500 dark:hover:text-teal-400 hover:border-teal-400/60 active:scale-95 transition-all duration-300 ${className}`}
    >
      {isDark ? <Sun size={18} weight="bold" /> : <Moon size={18} weight="bold" />}
    </button>
  );
};
